
<template>
  <div class="faq">
    <header>
      <span class="title">常见问题</span>
      <div class="right">
        <el-button size="small" @click="addOpen()" type="primary" v-if="funAuth.includes(52)">新 建</el-button>
      </div>
    </header>
    <el-table :data='tableData' tooltip-effect='dark' style='width: 100%;height: calc(100% - 122px);' class="el-table-01">
      <el-table-column
        prop="title"
        label="名称"
        width="300">
      </el-table-column>
      <el-table-column
        label="排序"
        width="134">
        <template slot-scope="scope">
          <i class="iconfont icon-jianjuxiao" @click="sort(scope.row.id,1,scope.row.sort)"></i>
          <i class="iconfont icon-jianjuda" @click="sort(scope.row.id,2,scope.row.sort)"></i>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="236">
        <template slot-scope="scope">
          {{scope.row.create_time | formatDate('yyyy-MM-dd HH:mm')}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <span class="operator-btn" @click="openEdit(scope.row)" v-if="funAuth.includes(53)">编辑</span>
          <span class="operator-btn" @click="del(scope.row.id)" v-if="funAuth.includes(54)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change='handleSizeChange'
      @current-change='handleCurrentChange'
      :current-page='pageNum'
      :page-sizes='[10, 20, 50, 100]'
      :page-size='pageSize'
      layout='total, sizes, prev, pager, next, jumper'
      :total='tableTotal'>
    </el-pagination>
    <!-- 新增弹窗 -->
    <div class="mask n1" v-if="faqDialog"></div>
    <transition name="slide">
      <help-document-create v-if="faqDialog"></help-document-create>
    </transition>
  </div>
</template>
<script>
import helpDocumentCreate from './help-document-create.vue'
import { mapState, mapMutations } from 'vuex'
import mixin from '@/common/js/mixins.js'
export default {
  components: {
    helpDocumentCreate
  },
  name: 'FAQ', // 常见问题组件
  mixins: [mixin],
  data () {
    return {
      moduleId: 16, // 模块ID
      dialogAdd: false,
      editorHTML: '',
      currentId: '',
      pageNum: 1,
      pageSize: 10,
      tableTotal: 0,
      tableData: []
    }
  },
  created () {
    this.getMenuDetailList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  methods: {
    // 打开编辑 todo
    openEdit (obj) {
      this.setFaqDialog(true)
      this.setTheme('常见问题')
      this.openEditDialog(obj)
    },
    // 获取列表
    getMenuDetailList () {
      let obj = {
        'menu_id': -1, // -1问题，-2版本更新
        'pageSize': this.pageSize,
        'pageNum': this.pageNum
      }
      this.$http.queryDocList(obj).then(res => {
        this.tableData = res.dataList
        this.pageNum = res.pageInfo.pageNum
        this.pageSize = res.pageInfo.pageSize
        this.tableTotal = res.pageInfo.totalRows
      })
    },
    // 页容量
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.pageNum = 1
      this.getMenuDetailList()
    },
    // 跳页
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      this.getMenuDetailList()
    },
    // 删除列表
    del (id) {
      this.$confirm('确定要删除该数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteDoc({'id': id}).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '操作成功!'
          })
          // 刷新列表
          this.getMenuDetailList()
        })
      })
    },
    // 排序
    sort (id, direction, sort) {
      let obj = {
        'id': id,
        'menu_id': -1, // -1问题，-2版本更新
        'sort': sort,
        'direction': direction // int 交换方向，1和前面的交换，2和后面的交换
      }
      this.$http.updateDocSort(obj).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.getMenuDetailList()
      })
    },
    // 新建
    addOpen () {
      this.openEditDialog(null)
      this.setTheme('常见问题')
      this.setFaqDialog(true)
    },
    ...mapMutations({
      setFaqDialog: 'FAQ_DIALOG', // 开关公共新增弹窗
      openEditDialog: 'OPENEDIT', // 打开公共编辑弹窗
      setTheme: 'THEME' // 设置公共新增弹窗主题
    })
  },
  watch: {
    faqDialog () {
      if (!this.faqDialog) {
        this.getMenuDetailList()
      }
    }
  },
  computed: {
    ...mapState({
      faqDialog: state => state.faq.faqDialog // 常见问题新增弹窗
    })
  }
}
</script>
<style lang="scss">
.faq {
  height: 100%;
  overflow: auto;
  .span-title {
    margin: 0 15px;
  }
  .el-table{
    .icon-jianjuxiao,.icon-jianjuda {
      cursor: pointer;
      &:hover {
        color: #1890FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/help/FAQ.vue